import { render, staticRenderFns } from "./UberEventNewPopup.vue?vue&type=template&id=29d65801&scoped=true&"
import script from "./UberEventNewPopup.vue?vue&type=script&lang=js&"
export * from "./UberEventNewPopup.vue?vue&type=script&lang=js&"
import style0 from "./UberEventNewPopup.vue?vue&type=style&index=0&id=29d65801&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d65801",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
